import React, { useEffect } from 'react';
import { Case, getDisplayName } from "../hooks/useCasesApi";
import { useDocuments } from '../hooks/useDocuments';

interface CaseDetailsProps {
  caseData: Case;
  onClose: () => void;
}

export default function CaseDetails({ caseData, onClose }: CaseDetailsProps) {
  const { documents, fetchDocuments } = useDocuments(caseData.id);
  
  // Debug: Log case data to see what's available
  console.log('Case Details - caseData:', caseData);
  console.log('Case Details - country field:', caseData.country);
  
  // Fetch documents when case changes
  useEffect(() => {
    fetchDocuments();
  }, [caseData.id, fetchDocuments]);

  return (
    <div className="case-details-modal">
        <div className="modal-header">
          <h2>Case Details - {caseData.caseId}</h2>
          <button onClick={onClose} className="close-btn">×</button>
        </div>

        <div className="case-details-content">
          {/* Overview Content */}
          <div className="overview-content">
            {/* Case Information */}
            <div className="case-info-section">
              <h3>📋 Case Information</h3>
              <div className="info-grid">
                <div className="info-item">
                  <label>Case ID:</label>
                  <span>{caseData.caseId}</span>
                </div>
                <div className="info-item">
                  <label>Status:</label>
                  <span className={`status-badge status-${caseData.status.toLowerCase().replace(' ', '-')}`}>
                    {caseData.status}
                  </span>
                </div>
                <div className="info-item">
                  <label>Priority:</label>
                  <span className={`priority-badge priority-${caseData.priority.toLowerCase()}`}>
                    {caseData.priority}
                  </span>
                </div>
                <div className="info-item">
                  <label>Type:</label>
                  <span>{caseData.caseType}</span>
                </div>
                <div className="info-item">
                  <label>Country:</label>
                  <span className="country-value">{caseData.country || 'USA'}</span>
                </div>
              </div>
            </div>

            {/* Client Information */}
            <div className="client-info-section">
              <h3>👤 Client Information</h3>
              <div className="info-grid">
                <div className="info-item">
                  <label>Name:</label>
                  <span>{caseData.clientName}</span>
                </div>
                <div className="info-item">
                  <label>Email:</label>
                  <span>{caseData.clientEmail}</span>
                </div>
              </div>
            </div>

            {/* Progress Summary */}
            <div className="progress-summary-section">
              <h3>📊 Progress Summary</h3>
              <div className="progress-grid">
                <div className="progress-item">
                  <div className="progress-circle">
                    <span className="progress-number">{documents.length}</span>
                    <span className="progress-label">Documents Uploaded</span>
                  </div>
                </div>
                <div className="progress-item">
                  <div className="progress-circle">
                    <span className="progress-number">0</span>
                    <span className="progress-label">Forms Completed</span>
                  </div>
                </div>
                <div className="progress-item">
                  <div className="progress-circle">
                    <span className="progress-number">{documents.length > 0 ? 'Started' : '0%'}</span>
                    <span className="progress-label">Overall Progress</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="modal-actions">
          <button onClick={onClose} className="close-btn">
            Close
          </button>
        </div>
      </div>
  );
} 